export default __webpack_public_path__ + "static/media/filter.c432d3d1.svg";